function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";

/*
 * Anchors a Kendo popup (MultiSelect / ComboBox / etc.) to a LOCAL positioned
 * wrapper, so the panel opens directly under the control. Without this the
 * body-portal anchor math drops the panel well below the picker in this app's
 * layout (the same reason PlunkDropDown wraps DropDownList).
 *
 * Usage (render-prop hands back the DOM anchor once it's mounted):
 *   <PopupAnchor>
 *     {(anchor) => <MultiSelect ... popupSettings={anchor ? { appendTo: anchor } : undefined} />}
 *   </PopupAnchor>
 */
export default class PopupAnchor extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "setAnchor", el => {
      if (el && this._el !== el) {
        this._el = el;
        this.forceUpdate();
      }
    });
  }
  render() {
    const {
      style,
      children
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      ref: this.setAnchor,
      style: {
        position: "relative",
        display: "inline-block",
        ...(style || {})
      }
    }, children(this._el));
  }
}